export default __webpack_public_path__ + "static/media/imgMoneyModal.71002560.png";